export default __webpack_public_path__ + "static/media/FAC3.c0067e50.jpg";